import React, { useRef, useEffect } from 'react';

const defaultOptions = {
  trim: false,
  shouldUpdateStateOnDefaultValueChange: void 0
};
const useInputControls = (defaultValue = "", optionsArg) => {
  const { trim, onChange: onChangeProp, debounce = 0, shouldUpdateStateOnDefaultValueChange } = {
    ...defaultOptions,
    ...optionsArg
  };
  const [value, setValue] = React.useState(defaultValue);
  const shouldUpdateStateOnDefaultValueChangeRef = useRef(shouldUpdateStateOnDefaultValueChange);
  shouldUpdateStateOnDefaultValueChangeRef.current = shouldUpdateStateOnDefaultValueChange;
  useEffect(() => {
    if (shouldUpdateStateOnDefaultValueChangeRef.current?.()) {
      setValue(defaultValue);
    }
  }, [
    defaultValue
  ]);
  const timeout = React.useRef(null);
  const onChange = React.useCallback((eventOrValue) => {
    let nextValue = typeof eventOrValue === "string" ? eventOrValue : eventOrValue.target.value;
    if (trim) {
      nextValue = nextValue.trim();
    }
    setValue(nextValue);
    if (timeout.current) clearTimeout(timeout.current);
    if (debounce > 0) {
      timeout.current = window.setTimeout(() => {
        onChangeProp?.(nextValue);
      }, debounce);
    } else onChangeProp?.(nextValue);
  }, [
    trim,
    onChangeProp,
    setValue,
    debounce
  ]);
  const clear = React.useCallback(() => {
    setValue("");
  }, [
    setValue
  ]);
  const res = React.useMemo(() => ({
    value,
    sanitizedValue: value.trim(),
    onChange,
    clear,
    set: setValue
  }), [
    value,
    onChange,
    clear,
    setValue
  ]);
  return res;
};

export { useInputControls };
//# sourceMappingURL=useInputControls.js.map
